<template lang="pug">
  div
</template>
<script>
export default {
  name: 'RedirectPage',
  created() {
    const queryEncoded = this.$route.query?.query;
    let queryParsed = {};

    if (queryEncoded) {
      queryParsed = JSON.parse(queryEncoded);
    }

    this.$router.push({
      name: this.$route.params.route,
      params: this.$route.query,
      query: queryParsed,
    });
  },
};
</script>

<style scoped>

</style>
